"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("../store/initial"));
exports.default = (state = initial_1.default.employeeDetail, action) => {
    switch (action.type) {
        case action_type_1.default.SET_EMPLOYEE_DETAIL:
            return action.data;
        case action_type_1.default.RESET_STORE:
            // @ts-expect-error
            return initial_1.default.employeeDetail;
        case action_type_1.default.SWITCH_WORKSPACE:
            // @ts-expect-error
            return initial_1.default.employeeDetail;
        default:
            // @ts-expect-error
            return state;
    }
};
